module.exports = __webpack_public_path__ + "img/winking-face.c798c98e.svg";